import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiPath } from '@/constants/defaultValues';
import { getCurrentLanguage } from '@/helpers/Utils';
import { Get,PostBlob } from '@/api/api-middleware';
import { downloadFile } from '@/helpers/Utils';

export const fetchExportMapping = createAsyncThunk(
  'exportMapping/fetchExportMapping',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}api/Reporting/GetEntityExportMapping/${params?.type}/${
          getCurrentLanguage() === 'en' ? 1 : 0
        }`,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.ID,
          nameEn: item.Name,
          nameAr: item.Name,
          label: item.Name,
          value: item.ID,
          code: item.Code,
          tableType: item?.TableType,
          itemIndex: item?.ItemIndex
        })) ?? [];
      return mappedData;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


export const fetchExportPowerBIGetEmployeeData = createAsyncThunk(
  'exportMapping/fetchExportMapping',
  async (data, thunkAPI) => {
    try {
      const response = await PostBlob({
        url: `${apiPath}api/Reporting/PowerBI_GetEmployeeData`,
        data,
      });
      if (response) {
        downloadFile(response);
        return 1;
      } else return -1;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  exportMappingList: [],
  loading: false,
  error: '',
};

const exportMappingSlice = createSlice({
  name: 'exportMapping',
  initialState,
  reducers: {
    clearExportMappingList: (state) => {
      state.exportMappingList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExportMapping.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExportMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.exportMappingList = action.payload;
        state.error = '';
      })
      .addCase(fetchExportMapping.rejected, (state, action) => {
        state.loading = false;
        state.exportMappingList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});
export const { clearExportMappingList } = exportMappingSlice.actions;
export default exportMappingSlice.reducer;
